import { defineMessages } from 'react-intl';

export const messages: {
	cancelButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	clearAllFiltersButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirmButton: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	header: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	headerSubtext: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	header: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header',
		defaultMessage: 'Build dynamic cards',
		description: 'Header for dynamic content modal dialog',
	},
	headerSubtext: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.header-subtext',
		defaultMessage:
			'Create a customized set of automatically populated cards that display the latest information. Use filters to select card content by label, space, owner, and more.',
		description: 'Header subtext for dynamic content modal dialog',
	},
	clearAllFiltersButton: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.clear-all-filters-button',
		defaultMessage: 'Clear all filters',
		description: 'Button text for clearing all filters in dynamic content modal dialog',
	},
	cancelButton: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Button text for cancelling in dynamic content modal dialog',
	},
	confirmButton: {
		id: 'company-hub.cards-extension.link-cards-content.card-components.dynamic-content-modal-dialog.confirm-button',
		defaultMessage: 'Confirm',
		description: 'Button text for confirming in dynamic content modal dialog',
	},
});
